<template>
    <div class="row main-content" id="top">
        <div class="col-md-2 sidebar">
            <h1 class="font-weight-normal pb-3">ADMIN: dynamic spec sheet portal</h1>
            <div class="lines d-sm-none d-none d-lg-block "></div>
        </div>
        <div class="col-md-10" v-if="loading">
            <div class="vh-100 d-flex justify-content-center align-items-center">
            <vue-loaders-ball-beat scale="2" color="black" />
            </div>
        </div>
        <div class="col-md-10 " v-else>
            <form action="?" method="GET" class="specsheet-form ">
                <label><strong>ENTER STYLE:</strong> <small>(click on the style as it populates below)</small></label>
                <input type="text" name="prodStyle"  v-model="searchValue">

                <div v-if="showList && productList" class="search-product-list mt-2">
                    <div >
                        <p class="text-uppercase"><strong>showing result:</strong> <span>{{displayProdLimit}} OF {{productList.length }}</span></p>
                    </div>
                    <ul>
                        <li v-for="(product,index) in productList.slice(0,displayProdLimit)" :key="'product' + index">

                            <!-- {{ product.prod_key }} | {{ product.brand }} | IREF:{{ product.prod_id }} | PIM:{{ product.ew_style_id }} -->
                            <div class="d-flex flex-row p-1" v-if="product">
                                <section class="specsheet-thumbnail-img">
                                    <div v-if="product.images.length!=0 ">
                                        <specsheet-prodimage  :prodImageDetail="product.images"></specsheet-prodimage>
                                    </div>
                                    <div v-else>
                                        <img src="/images/products/img-coming-soon.png" alt="image">
                                    </div>
                                </section>
                                <!-- <section v-if="product.images.length>0" class="specsheet-thumbnail-img">
                                    <section v-if="product.images[0].folder">

                                        <div v-if="checkFile('/images/pim/600/'+product.images[0].folder+'/'+product.images[0].img+'.jpg')">
                                            <b-img
                                                    :src="`/images/pim/600/${product.images[0].folder}/${product.images[0].img}.jpg`"
                                                    class="product-image"
                                            ></b-img>
                                        </div>
                                        <div v-else>
                                            <img src="/images/products/img-coming-soon.png" alt="image">
                                        </div>

                                    </section>
                                    <section v-else>
                                        <img src="/images/products/img-coming-soon.png" alt="image">
                                    </section>
                                </section>

                                <section class="specsheet-thumbnail-img" v-else>
                                    <img src="/images/products/img-coming-soon.png" alt="image">
                                </section> -->

                                <div class=" p-2">
                                    <!-- <router-link
                                        :to="{
                                            name: 'product',
                                            params: { id: product.prod_id }
                                        }"
                                    > -->
                                    <div class="spec-sheet-results">
                                        <strong v-html="product.brand"></strong>
                                        <p
                                            class="desc"
                                            v-html=" product.short_desc"
                                        ></p>
                                        <span class="font-weight-bold">
                                            {{ product.prod_key}}
                                        </span>
                                    </div>
                                    <!-- </router-link> -->
                                    <p class="d-flex flex-wrap">
                                        <button class="btn-round-red pt9rem" type="submit" @click.prevent="downloadSpecs(product.prod_id,product.prod_key)">DOWNLOAD SPECSHEET</button>
                                        <span v-if="product.doc.length != 0" >
                                            <span v-for="(doc,index) in product.doc" :key="index" class="d-flex flex-wrap">
                                                <span v-if="doc.type==26">
                                                    <button class="btn-round-red pt9rem" type="submit" @click.prevent="downloadTechPack(doc)">DOWNLOAD TECH PACK</button>
                                                    <button class="btn-round-red pt9rem"  type="submit" @click.prevent="downloadSpecsAndTechPack(product)">DOWNLOAD SPECSHEET + TECH PACK</button>
                                                </span>
                                            </span>
                                        </span>
                                    </p>
                                </div>
                            </div>

                        </li>

                    </ul>
                    <div class="mt-2">
                        <p class="text-uppercase"><strong>showing result:</strong> <span>{{displayProdLimit}} OF {{productList.length }}</span></p>
                    </div>
                    <div class="pt-3 d-flex flex-row justify-content-center">
                        <button type="button" class="button" v-if="productList.length>=11 && productList.length!==displayProdLimit" @click="showMore()">SHOW MORE</button>
                    </div>

                </div>
                <div v-if="noRecord" class="mt-2">
                    <strong id="no-record">NO RECORDS FOUND</strong>
                </div>
            </form>
        </div>


    </div>
</template>
<style  lang="scss" scoped>
#no-record{
    font-size:1.2rem;
}
.specsheet-thumbnail-img img{
    width:150px; height:150px;
}

</style>
<script>
import {mapState} from "vuex";
export default{
    data(){
        return{
            loading:false,
            productList:[],
            searchValue:null,
            showList:false,
            noRecord:false,
            displayProdLimit:0,
            pdfUrl:'',
            currentURL:window.location.origin
        };
    },
    created(){

    },
    computed:{

    },
    methods:{
        showMore(){
            this.displayProdLimit=this.displayProdLimit+10;
            if(this.displayProdLimit>=this.productList.length){
                this.displayProdLimit=this.productList.length;
            }
        },

        // onclick download spec sheet generate spec sheet and display
        async downloadSpecs(id,key){
            this.loading=true;
            document.getElementById("top").scrollIntoView({ block: 'start',  behavior: 'smooth' });
            try{
                await axios.get(`/api/specsheet/${id}/${key}/`).then(response=>{
                    this.loading=false;

                    const pdfUrl = window.location.origin+response.data;
                    const link = document.createElement('a');
                    link.href = pdfUrl;
                    link.target = '_blank';
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });
            }catch (error) {
                console.error(error);
            }
        },
        downloadTechPack(docInfo){
            document.getElementById("top").scrollIntoView({ block: 'start',  behavior: 'smooth' });
            const pdfUrl = window.location.origin+"/images/pim/Original/"+docInfo.folder+"/"+docInfo.doc+".pdf";
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        async downloadSpecsAndTechPack(product){
            document.getElementById("top").scrollIntoView({ block: 'start',  behavior: 'smooth' });
            this.loading=true;
            axios.post(`/api/specandtechpack`,product).then(response=>{
                this.loading=false;
                // console.log(response.data);
                const pdfUrl = window.location.origin+response.data;
                const link = document.createElement('a');
                link.href = pdfUrl;
                link.target = '_blank';
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });

        },


    },
    watch:{
        // on change search input value
        async searchValue(newInput){
            if(newInput.length>2){
                if(newInput=="" || newInput==null){
                    this.productList=[];
                    this.showList=false;
                }else{
                    try {
                        await axios.get(`/api/searchProductList/${newInput}/`).then(response => {
                            this.showList=true;
                            this.productList=response.data.data;
                            if(this.productList.length==0){
                                this.productList=[];
                                this.showList=false;
                                this.noRecord=true;
                            }
                            if(this.productList.length<=10){
                                this.displayProdLimit=this.productList.length;
                            }else{
                                this.displayProdLimit=10;
                            }
                        });

                    } catch (error) {
                        this.showList=false;
                        this.errors = error.response && error.response.data.errors;
                    }
                }
            }else{
                this.productList=[];
                    this.showList=false;
            }


        },
    }

}
</script>

<style scoped>
    .spec-sheet-results {
        font-family: "acumin-pro", Helvetica, Arial, sans-serif;
    }
</style>
